import { getKeys } from '../../adapters/utils';
import { getData, requiredSchemaVariables, getSdStatus, getSlug, getFullUrl, setFullUrl, updateItemDataWithSlug, } from './get-data';
import { getDataLegacy, requiredSchemaVariablesLegacy, getSdStatusLegacy, getSlugLegacy, getFullUrlLegacy, setFullUrlLegacy, updateItemDataWithSlugLegacy, } from './get-data-legacy';
export var IDs = {
    ID: 'service.id',
    PAGE_URL: 'service.url',
    TITLE: 'service.info.name',
    DESCRIPTION: 'service.info.description',
    STATUS: 'service.status',
    IMAGE_HEIGHT: 'service.mainImage.height',
    IMAGE_ID: 'service.mainImage.id',
    IMAGE_WIDTH: 'service.mainImage.width',
    MAIN_IMAGE: 'service.mainImage.url',
    IMAGE_ALT: 'service.mainImage.altText',
    CATEGORY_NAME: 'service.category.name',
    PRICE_AMOUNT: 'service.price.amount',
    CURRENCY: 'service.price.currency',
    START_DATE: 'service.start-date',
    END_DATE: 'service.end-date',
    PRICE_TEXTUAL: 'service.price.textual',
    SESSION_TYPE: 'service.type',
    FIRST_SESSION: 'service.session.first',
    LAST_SESSION: 'service.session.last',
    SD_DISABLE_SCHEMA: 'service.disable-schema',
    AVAILABILITY: 'service.availability',
    INSTRUCTOR_NAME: 'service.instructor-name',
    INSTRUCTOR_IMAGE: 'service.instructor-image',
    SD_JSON_PROVIDER: 'service.structured-data.provider',
    SD_JSON_IMAGES: 'service.structured-data.images',
    SD_JSON_OFFERS: 'service.structured-data.offers',
    IS_COURSE_SESSION_TYPE: 'service.is-course-session-type',
    MEDIA_ITEMS: 'service.media',
    FULL_DESCRIPTION: 'service.full-description',
    DISABLE_IMAGES_SCHEMA: 'service.images-schema.disable',
    IMAGES_SD_STATUS: 'service.structured-data.images-status',
};
var userVisible = [
    IDs.TITLE,
    IDs.DESCRIPTION,
    IDs.SESSION_TYPE,
    IDs.PAGE_URL,
    IDs.PRICE_AMOUNT,
    IDs.CURRENCY,
    IDs.MAIN_IMAGE,
];
var userVisibleSdOnly = [
    IDs.IMAGE_HEIGHT,
    IDs.IMAGE_WIDTH,
    IDs.END_DATE,
    IDs.AVAILABILITY,
    IDs.INSTRUCTOR_NAME,
    IDs.INSTRUCTOR_IMAGE,
    IDs.SD_JSON_PROVIDER,
    IDs.SD_JSON_IMAGES,
    IDs.SD_JSON_OFFERS,
];
var SchemaTypes = {
    BOOKINGS_SERVICE: 'bookings-service-preset',
    BOOKINGS_SERVICE_IMAGES: 'bookings-service-images',
};
var isV2Object = function (item) { return (item === null || item === void 0 ? void 0 : item.service) && !(item === null || item === void 0 ? void 0 : item.serviceResponse); };
var getSdStatusBase = function (item, itemData, schemaType) {
    if (schemaType === SchemaTypes.BOOKINGS_SERVICE_IMAGES) {
        return IDs.IMAGES_SD_STATUS;
    }
    return isV2Object(item)
        ? getSdStatus(IDs, item, itemData, schemaType)
        : getSdStatusLegacy(IDs, item, itemData, schemaType);
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: function (item) {
        return isV2Object(item)
            ? requiredSchemaVariables(IDs, item)
            : requiredSchemaVariablesLegacy(IDs, item);
    },
    getData: function (item) {
        return isV2Object(item)
            ? getData(IDs, item)
            : getDataLegacy(IDs, item);
    },
    getSdStatus: getSdStatusBase,
    getSlug: function (item) { return (isV2Object(item) ? getSlug(item) : getSlugLegacy(item)); },
    getFullUrl: function (item) {
        return isV2Object(item) ? getFullUrl(item) : getFullUrlLegacy(item);
    },
    setFullUrl: function (item, url) {
        if (url === void 0) { url = ''; }
        return isV2Object(item) ? setFullUrl(item, url) : setFullUrlLegacy(item, url);
    },
    updateItemDataWithSlug: function (item, slugValue) {
        return isV2Object(item)
            ? updateItemDataWithSlug(item, slugValue)
            : updateItemDataWithSlugLegacy(item, slugValue);
    },
    getKeys: function () { return getKeys(IDs, userVisible); },
    getSdKeys: function () { return getKeys(IDs, userVisibleSdOnly); },
    getDefaultSchemaType: function () {
        return SchemaTypes.BOOKINGS_SERVICE;
    },
};
